<template>
  <div class="flex items-center gap-2">
    <p class="text-[13px] text-txmain/60">Формат</p>
    <div class="price-select price-select-bg">
      <el-select
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        placeholder="Выбрать"
        popper-class="price-select__el bg-[#F1F5F9]"
      >
        <el-option
          v-for="item in prices"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
          <span class="cursor-pointer">
            {{ item.label }}
          </span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface PriceOption {
    label: string;
    value: string;
  }

  defineProps<{
    modelValue: string;
    prices: PriceOption[];
  }>();

  defineEmits<{
    'update:modelValue': [value: string];
  }>();
</script>

<style lang="scss" scoped>
  .price-select {
    .el-select {
      min-width: auto;
      width: auto;
      height: 30px !important;
      min-height: 30px !important;

      :deep(.el-select__wrapper) {
        border-radius: 8px !important;
        border: 0 !important;
        height: 30px !important;
        min-height: 30px !important;
        padding: 0 6px;
        max-width: 150px;
        background-color: #3176ff14 !important;

        &.is-disabled {
          background-color: #4292f41a !important;
          border: 1px solid #e3e8eb !important;
        }

        .el-select__selected-item.el-select__placeholder {
          position: relative;
          transform: unset;
          cursor: pointer;
        }

        .el-select__selected-item.el-select__placeholder span {
          font-size: 14px !important;
          cursor: pointer;
        }
      }

      :deep(.el-icon.el-select__caret.el-select__icon) {
        svg {
          width: 14px;
          height: 14px;

          path {
            fill: #556d80 !important;
          }
        }

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
    }

    &.bg-light {
      :deep(.el-select__wrapper) {
        background-color: #f1f4f9 !important;
      }
    }
  }

  .el-select {
    :deep(.el-select__wrapper) {
      @apply border border-border;
    }
  }

  .price-select-bg {
    .el-select {
      :deep(.el-select__wrapper) {
        @apply border border-border !bg-primary/10;
      }
    }
  }
</style>
